import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { EditorHCSv2_Manager } from '../hcs-v2/refactoring/EditorHCSv2_Manager/index.js';
import { ModuleFE_Referencable } from '../../_entity/referencable/index.js';
export class ATS_HCSv2 extends ComponentSync {
    static screen = {
        name: `DevTool - HCSv2`,
        renderer: this,
        group: 'HCSv2',
        modulesToAwait: [ModuleFE_Referencable],
    };
    static defaultProps = {
        pageTitle: () => this.screen.name
    };
    constructor(p) {
        super(p);
    }
    render() {
        return _jsx(EditorHCSv2_Manager, {});
    }
}
//# sourceMappingURL=ATS_HCSv2.js.map